export { default } from './InputArea';
export * from './InputArea.types';
